require('./style.less');

var Marionette = require('marionette'),
    Backbone = require('backbone'),
    HitsTableView = require('./hitsTableView/view'),
    HitsActionRowView = require('./hitsActionRow/view'),
    SearchSectionView = require('./searchesView/view'),
    ResultsHeaderView = require('./resultsHeader/view'),
    NoResultsView = require('./noResultsView/view');


module.exports = Marionette.LayoutView.extend({

    className: '#fr-results-wr',

    template: require('./template.hbs'),

    initialize: function( options ) {

        this.channel = options.channel;

        this.listenTo( this.channel, 'findAndRedact:updateActionRow', this._showHitsActionRowView );

    },

    regions: {
        searchSectionRegion:          '#fr-results-searches',
        resultsHeaderRow:             '#fr-results-header-row',
        hitsActionRowRegion:          '#fr-action-row',
        hitsTableRegion:              '#fr-hits-table',
        noResultsRegion:              '#fr-no-results'
    },

    onBeforeShow: function() {

        this._showSearchesView();

        if ( this.channel.request('state').searchHasResults() ) {

            this.resultsHeaderRow.show( new ResultsHeaderView({
                channel: this.channel
            }));
            this._showHitsActionRowView();
            this._showHitsTable();

        } else
        {
            this.noResultsRegion.show( new NoResultsView({
                channel: this.channel,
                searchTerms: this.channel.request('state').get('searches').pluck('searchTerm')
            }));
        }

    },

    _showSearchesView: function() {

        this.searchSectionRegion.show( new SearchSectionView({
            channel: this.channel
        }));

    },

    _showHitsActionRowView: function() {

        this.hitsActionRowRegion.show( new HitsActionRowView({
            channel: this.channel
        }) );

    },

    // could be diff depending on the note type
    // actually have the same columns always; but the hit view 2nd row could have a zone properties section
    _showHitsTable: function() {

        this.hitsTableRegion.show( new HitsTableView({
            channel: this.channel
        }) );


    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/view.js
 ** module id = 612
 ** module chunks = 0
 **/